export default __webpack_public_path__ + "static/media/help-desk-9.e5f2a034.png";